import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import util from "../util/util";

export default function PodListSearchForm(props) {
  const usageStatuses = [
    {
      label: `All`,
      value: ``
    },
    {
      label: `Unused`,
      value: `true`
    },
    {
      label: `Used`,
      value: `false`
    }
  ];

  const [search, setSearch] = useState("");
  const [status, setStatus] = useState(util.podStatuses[0].value);
  const [usage, setUsage] = useState(usageStatuses[0].value);
  const [sort, setSort] = useState(`-created`);

  useEffect(() => {
    setSearch(props.search);
    setStatus(Number(props.status));
    setUsage(props.unused);
    setSort(props.sort);
  }, [props]);

  // if the key pressed is `enter` then submit the search form;
  const onKeyPress = e => {
    if (e.key === `Enter`) {
      onSearchSubmit();
    }
  };

  // reset search form values to their default state;
  const onSearchReset = () => {
    setSearch("");
    setStatus(util.podStatuses[0].value);
    setUsage(usageStatuses[0].value);
    setSort(`-created`);
  };

  // go to a new URL with the selected form values;
  const onSearchSubmit = () => {
    let url = `${util.returnPodListUrl()}?sort=${sort}`;

    if (search.length) {
      url = `${url}&search=${search}`;
    }

    if (status !== util.podStatuses[0].value) {
      url = `${url}&status=${status}`;
    }

    if (usage !== usageStatuses[0].value) {
      url = `${url}&unused=${usage}`;
    }

    const params = {
      url: url,
      search: search,
      status: status,
      usage: usage,
      sort: sort
    };

    props.searchSubmit(params);
  };

  return (
    <div className="form-inline search-form">
      <div className="form-group">
        <label htmlFor="search-form__search">Search</label>
        <input
          type="text"
          id="search-form__search"
          className="form-control"
          value={search}
          autoFocus
          onChange={e => setSearch(e.target.value.trim())}
          onKeyPress={e => onKeyPress(e)}
        />
      </div>

      <div className="form-group">
        <label htmlFor="search-form__status">Status</label>
        <select
          id="search-form__status"
          className="form-control"
          value={status}
          onChange={e => setStatus(Number(e.target.value))}
        >
          {util.podStatuses.map(option => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </div>

      <div className="form-group">
        <label htmlFor="search-form__status">Usage</label>
        <select
          id="search-form__status"
          className="form-control"
          value={usage}
          onChange={e => setUsage(e.target.value)}
        >
          {usageStatuses.map(option => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </div>

      <div className="search-form__buttons search-form__buttons--block">
        <div className="search-form__buttons">
          <button className="btn btn-default" onClick={() => onSearchSubmit()}>
            <i className="fa fa-search" aria-hidden="true"></i>
            Apply Filters
          </button>

          <button className="btn btn-link" onClick={() => onSearchReset()}>
            Reset Filters
          </button>
        </div>
      </div>
    </div>
  );
}

PodListSearchForm.propTypes = {
  search: PropTypes.string,
  sort: PropTypes.string, // not editable from this component, but needs to be passed in the form;
  status: PropTypes.number,
  unused: PropTypes.string,
  searchSubmit: PropTypes.func
};
